import "./style.scss";

const UserImage = (props) => {
    return (
        <div className="box-user">
            <div className="box-left">
                {props.userImage && <img src="/icon/ic-user.svg" alt="" srcSet="" />}
                {props.svgIcon && (
                    <svg>
                        <use xlinkHref="/sprite.svg#icon-user-black" />
                    </svg>
                )}
            </div>
            <div className="box-right">
                {/* <span>{props.name ? props.name : "User"}</span> */}
                <span>{props.email ? props.email : "info@email.com"}</span>
            </div>
        </div>
    );
};

export default UserImage;
